export interface EDocsResponse {
  firstName: string;
  lastName: string;
  customerIssuedDocumentSummaryList: CustomerIssuedDocumentSummaryList;
  advisoryFlagForCombine: boolean;
}

export interface EDocRequest {
  loyaltyNumber: string;
  requestType: string;
  app: string;
  cartId: string;
}

export interface EDocAPIErrorResponse {
  paymentError: PaymentError;
  advisoryFlagForCombine: boolean;
}

export interface PaymentError {
  error: Error;
}

export interface Error {
  message: Message;
}

export interface Message {
  code: string;
  errorKey: string;
  message: string;
  reasonMsg: string;
}

export interface VouchersResponse {
  voucherCount: string;
}

export interface EDocsAPIResponse {
  firstName: string;
  lastName: string;
  customerIssuedDocumentSummaryList: CustomerIssuedDocumentSummaryList;
  advisoryFlagForCombine: boolean;
}

export interface CustomerIssuedDocumentSummaryList {
  customerIssuedDocumentSummaries: CustomerIssuedDocumentSummaries[];
  allEdocsPreviouslySelected: boolean;
}

export interface CustomerIssuedDocumentSummaries {
  primary: unknown;
  ticketDesignator: boolean;
  ecredit: boolean;
  documentNum: string;
  issueLocalDate: string;
  expirationDate: string;
  personName: PersonName;
  documentTypeCode: string;
  documentSubTypeCode: string;
  documentVoided: unknown;
  documentSuspended: unknown;
  ecouponStatus: unknown;
  couponIsOpenStatus: boolean;
  redemptionCodeRequiredToDisplay: true;
  documentAssociatedToBooking: unknown;
  documentAssociatedToPrimaryCarrierBooking: unknown;
  documentTotalAmt: DocumentTotalAmt;
  requestedCurrencyValidated: unknown;
  digitsAfterDecimalForRequestedCurrencyValidated: unknown;
  valueInRequestedCurrencyValidated: unknown;
  originAirportCode: unknown;
  destinationAirportCode: unknown;
  flightDepartureDate: unknown;
  loyaltyMemberId: string;
  skymilesPin: unknown;
  phoneNum: unknown;
  docDescriptionText: string;
  enteredDocumentNumber: unknown;
  redemptionCode: string;
  isPrimary: unknown;
  osiMessages: unknown;
  agencyId: unknown;
  corpId: unknown;
  dlRecordLocator: unknown;
  skyBonusId: unknown;
  documentSource: string;
  emdText: string;
  dataText: string;
  highLevelDocType: string;
  isEcredit: boolean;
  isTicketDesignator: boolean;
  flightLegs: string[];
  usableValue: unknown;
  penaltyValue: unknown;
  termsAndConditions: TermsAndConditions[];
  documentHistory: unknown;
  transferTypeCode: string;
  documentStatus: string;
  redeemable: boolean;
  selectable: unknown;
  documentLongDesc: string;
  ticketDesignatorCode: string;
  transferList: unknown;
  bookingMessages: unknown;
  informationalMsgs: unknown;
  messages: string[];
  messageHeader: unknown;
  fareRuleAccountCode: string;
  multiPaxPNRsameDocTypeReqInd: string;
  companyId: unknown;
  residualAdvisoryErrorCode: unknown;
  aemAdvisoryMessages: unknown;
  aemSeverityLevelIcon: unknown;
  isNameMatch: unknown;
  spidAdvisoryIndicator: boolean;
}

export interface TermsAndConditions {
  blackoutPeriods: string[];
  carrierLists: string[];
  classOfServiceDesc: string;
  destinationListsDesc: string[];
  originListsDesc: string[];
  saturdayNightStayInd?: string;
  tripTypeCode: string;
}

export interface PersonName {
  firstName: string;
  lastName: string;
}

export interface DocumentTotalAmt {
  currencyEquivalentPriceAmt: CurrencyEquivalentPriceAmt;
}

export interface CurrencyEquivalentPriceAmt {
  currencyAmt: number;
  currencyCode: string;
  currencySymbol: string;
  decimalPrecisionCnt: number;
  iataDecimalPrecisionCnt: number;
}
